import { MembershipAttributes, ProfileAttributes } from '@loyalty/shared-common/profile-api-client';
import { blockedMemberColor } from '../../../shared/markers/BlockedMemberMarker';
import { testUserColor } from '../../../shared/markers/TestUserMarker';

export function getProfileColor(
  profile: ProfileAttributes,
  membership: MembershipAttributes,
): string | undefined {
  if (membership?.blocked) {
    return blockedMemberColor;
  }

  if (profile?.isTestUser) {
    return testUserColor;
  }
}
